import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingJpgToWebpConfig } from '@/data/landingConfig/landingJpgToWebpConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_JpgToWebp } from './schemaObject';

interface Props {}
const JpgToWebpConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_JpgToWebp} />
			<LandingTemplate
				data={landingJpgToWebpConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default JpgToWebpConverter;
